<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      ref="dialog"
      :max-width="width"
      :persistent="persistent"
    >
      <slot />
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "custom-dialog",
  props: {
    width: {
      type: Number,
      default: 600,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
